import { FC } from 'react';
import {
  ShopperEventCategory,
  chatActions,
  useAppDispatch,
} from '@vs-online-only-app/state';
import styled from 'styled-components';
import { IconAddToCart, IconRemoveFromCart } from '@vs-online-only-app/ui';
import { Stack, Typography, Link as MuiLink, Paper } from '@mui/material';
import { ShopperEventsByCategory } from '../selected-conversation/SelectedConversationShopperProfile';
import ShopperEventsList from './ShopperEventsList';

const Wrapper = styled(Paper)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};
  padding: ${({ theme }) => theme.spacing(2)};
`;

type Props = {
  category: ShopperEventCategory;
  events: ShopperEventsByCategory;
};

const ShopperEventsCategoryCard: FC<Props> = ({ category, events }) => {
  const dispatch = useAppDispatch();

  const setShopperEventCategory = () => {
    dispatch(chatActions.setSelectedShopperEventCategory(category));
  };

  return (
    <Wrapper elevation={0}>
      <Stack direction="row" justifyContent="space-between">
        <Typography fontWeight="bold">
          {category === ShopperEventCategory.RECENTLY_VIEWED &&
            'Recently viewed'}
          {category === ShopperEventCategory.BASKET_ADDED_REMOVED &&
            'Cart activities'}
          {category === ShopperEventCategory.PURCHASED &&
            `Purchased items (${events.purchased.length})`}
        </Typography>
        <MuiLink onClick={setShopperEventCategory} sx={{ cursor: 'pointer' }}>
          <Typography variant="body2">View all</Typography>
        </MuiLink>
      </Stack>
      {category === ShopperEventCategory.BASKET_ADDED_REMOVED && (
        <Stack gap={3}>
          <ShopperEventsList
            displayAsCarousel
            events={events[category].added}
            placeholder="No items in Cart"
            headerIcon={IconAddToCart}
            headerTitle="Added to cart"
          />
          <ShopperEventsList
            displayAsCarousel
            events={events[category].removed}
            placeholder="No items removed from Cart"
            headerIcon={IconRemoveFromCart}
            headerTitle="Removed from cart"
          />
        </Stack>
      )}
      {category === ShopperEventCategory.PURCHASED && (
        <ShopperEventsList
          displayAsCarousel
          events={events[category]}
          placeholder="No past purchases"
        />
      )}
      {category === ShopperEventCategory.RECENTLY_VIEWED && (
        <ShopperEventsList
          displayAsCarousel
          events={events[category]}
          placeholder="No items viewed"
        />
      )}
    </Wrapper>
  );
};

export default ShopperEventsCategoryCard;
